window.options.glideOptions = {
    type: 'slider',
    rewind: true,
    startAt: 0,
    perView: 3,
    breakpoints: {
        991: {
            perView: 2
        },
        767: {
            perView: 1
        }
    }
};
window.options.datepicker.dayViewHeaderFormat = 'MMMM YYYY';
window.options.datepicker.allowInputToggle = true;
